/* code for product page drawer is not opend */
document.addEventListener("DOMContentLoaded", function () {
  // Select all elements with either .iWishAdd or .iWishAddColl classes
  document.querySelectorAll(".iWishAdd").forEach(function (element) {
    element.addEventListener("click", function () {
      setTimeout(function () {
        // Click the first element with either .iwish-float-icon or .iWishView classes
        document.querySelector(".iwish-float-icon, .iWishView").click();
      }, 500);
    });
  });
});

/* code for redirect to cart page */
/*document.addEventListener("DOMContentLoaded", function () {
  // Select the body and add a click event listener to it
  document.body.addEventListener("click", function (event) {
    // Check if the clicked element has the 'cart-btn' class
    if (event.target.classList.contains("cart-btn")) {
      setTimeout(function () {
        // Redirect to the cart URL after 500ms
        window.location.href = "https://test-trainers.myshopify.com/cart";
      }, 500);
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Select the body and add a click event listener to it
  document.body.addEventListener("click", function (event) {
    // Check if the clicked element has the 'cart-btn' class
    if (event.target.classList.contains("cart-all-btn")) {
      setTimeout(function () {
        // Redirect to the cart URL after 500ms
        window.location.href = "https://test-trainers.myshopify.com/cart";
      }, 5000);
    }
  });
});*/

/* counter zero code */

/*document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    var iwC1 = document.querySelector(".iw-link__count").textContent;
    console.log("iwC1: ", iwC1);
    if (parseInt(iwC1) > 0) {
      document.querySelector(".iw-link__count").style.display = "block";
    } else {
      document.querySelector(".iw-link__count").style.display = "none";
    }
  }, 2000);

  document.body.addEventListener("click", function (event) {
    // Check if the clicked element is one of the specified selectors
    if (
      event.target.matches(".iWishAdd") ||
      event.target.matches(".iwish-backdrop") ||
      event.target.matches(".iwish_drawer_close")
    ) {
      setTimeout(function () {
        var iwC1 = document.querySelector(".iw-link__count").textContent;
        console.log("iwC1click: " + iwC1);
        if (parseInt(iwC1) > 0) {
          document.querySelector(".iw-link__count").style.display = "block";
        } else {
          document.querySelector(".iw-link__count").style.display = "none";
        }
      }, 500);
    }
  });
});*/

/*for counter add to cart in Dawn theme */
document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("click", function (event) {
    // Check if the clicked element has the class 'cart-btn' or 'cart-all-btn'
    if (
      event.target.classList.contains("cart-btn") ||
      event.target.classList.contains("cart-all-btn")
    ) {
      // Check if an element with the class 'cart-count-bubble' exists
      if (!document.querySelector(".cart-count-bubble")) {
        // If it doesn't exist, append a new bubble element inside the cart icon
        var bubble = document.createElement("div");
        bubble.classList.add("cart-count-bubble");
        var span = document.createElement("span");
        span.setAttribute("aria-hidden", "true");
        span.textContent = "0";
        bubble.appendChild(span);
        document.querySelector(".header__icon--cart").appendChild(bubble);
      }
    }
  });
});
// Select the element with the class .mst-wishlist-desktop
const wishlistButton = document.querySelector(".mst-wishlist-desktop");

// Add a click event listener to the .mst-wishlist-desktop element
wishlistButton.addEventListener("click", function () {
  setTimeout(function () {
    document.querySelector(".cart-btn-continue").textContent =
      "Folytassa a vásárlást";
  }, 1500);
});
